import { useRef, useState } from 'react';

import { PhoneDetails } from '@clients/accountsClient';
import { Customer } from '@clients/customersClient';
import CustomerPhonesRow from '@pages/accountDetail/tabs/phoneNumbers/CustomerPhonesRow';
import PhoneAddModal from '@pages/accountDetail/tabs/phoneNumbers/phoneNumber/phoneModals/PhoneAddModal';
import PhoneEditModal from '@pages/accountDetail/tabs/phoneNumbers/phoneNumber/phoneModals/PhoneEditModal';

type CustomerPhonesRowContainerProps = {
    account_id: number;
    customer: Customer;
    isLoading: boolean;
    onRefetch?: () => void;
    phoneNumbers: PhoneDetails[];
};

const CustomerPhonesRowContainer = ({
    account_id,
    customer,
    isLoading,
    onRefetch,
    phoneNumbers,
}: CustomerPhonesRowContainerProps) => {
    // add
    const [AddModalOpen, setAddModalOpen] = useState(false);

    const handleOnClickAdd = () => {
        setAddModalOpen(true);
    };

    const handleOnClickAddClose = () => {
        setAddModalOpen(false);
    };

    // edit
    const [phoneNumberEditModalSetOpen, setPhoneNumberEditModalSetOpen] =
        useState(false);

    const selectedPhoneId = useRef(0);

    const handleOnClickEdit = (phoneId: number) => {
        selectedPhoneId.current = phoneId;
        setPhoneNumberEditModalSetOpen(true);
    };

    const handleOnClickClose = () => {
        setPhoneNumberEditModalSetOpen(false);
        onRefetch();
    };

    return (
        <>
            <CustomerPhonesRow
                customerDetails={customer}
                phoneNumberDetails={phoneNumbers}
                isLoading={isLoading}
                handleOnClickAdd={handleOnClickAdd}
                handleOnClickEdit={handleOnClickEdit}
            />

            {AddModalOpen && (
                <PhoneAddModal
                    account_id={account_id}
                    customer={customer}
                    onClickClose={handleOnClickAddClose}
                    onRefetch={onRefetch}
                />
            )}

            {phoneNumberEditModalSetOpen && (
                <PhoneEditModal
                    phoneNumberDetail={phoneNumbers.find(
                        (phoneDetail) =>
                            phoneDetail.id == selectedPhoneId.current,
                    )}
                    onClickClose={handleOnClickClose}
                />
            )}
        </>
    );
};

export default CustomerPhonesRowContainer;
